
    import * as React from 'react';

    const SocialFacebook16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M9.214 1l2.425.009v2.454s-1.006-.004-1.414-.004c-.8 0-.746.311-.746 1.298v.731h2.16l-.389 2.553H9.48v6.858h-3V8.04H5V5.488h1.479V3.435s-.026-1.138.906-1.847C8.223.95 9.215 1 9.215 1" fillRule="evenodd" /></svg>
        </div>
      );
    };

    SocialFacebook16.displayName = 'SocialFacebook16';

    export default SocialFacebook16;
  